import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);




class Animation extends Component {

  constructor(element) {

    super(element)


    this.body = $('body')
    this.html = $('html')
    this.element = element
    this.el = $(element)

    this.ref = {
      show: [],
      logo: [],
      intro: null,
      intrologo: null,
      introtagline: null,
      introheader: null
    }

  }

  mount() {

      this.init = false

      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);

      this.renderQue = this.render.bind(this)
      stage.on("stage:scroll", this.renderQue);
      this.resize(stage);

      if(this.ref.intro) {
        gsap.to(this.ref.intro,
          {
            opacity: 0,
            scrollTrigger: {
              trigger: this.element,
              scrub: .3,
              start: "top top-=1%",
              end: "top top-=50%"
            },

          }
        )

        gsap.to(this.ref.introheader,
          {
            yPercent: -100,
            opacity: 0,
          //  overwrite: false,
            scrollTrigger: {
              trigger: this.element,
              scrub: true,
              start: "top top-=1%",
              end: "top top-=50%"
            },

          }
        )
        //
        gsap.to(this.ref.intrologo,
          {
            yPercent: -200,
            opacity: 0,
          //  overwrite: false,
            scrollTrigger: {
              trigger: this.element,
              scrub: true,
              start: "top top-=1%",
              end: "top top-=50%"
            },

          }
        )

        gsap.to(this.ref.introtagline, {
          yPercent: -200,
          opacity: 0,
          //  overwrite: false,
          scrollTrigger: {
            trigger: this.element,
            scrub: true,
            start: "top top-=1%",
            end: "top top-=50%"
          },

        })
      }

  }


  resize(e){

    this.render(e);
  }

  render(e){


    _each(this.ref.show, (el)=>{
      const img = el.getBoundingClientRect();
      $(el).toggleClass('inview', img.top < 1.1*stage.h)
    })


  }


  unmount() {

   stage.removeListener("stage:resize", this.resizeQue);
   stage.removeListener("stage:scroll", this.renderQue);

  }


}

module.exports = Animation
